import { StateCreator } from 'zustand';

import { UnreadState, UnreadStore } from './types';

const INITIAL_UNREAD_STATE: UnreadState = {
  unreadByTaskGroup: {},
};

export const createUnreadSlice: StateCreator<UnreadStore> = (set, get) => ({
  ...INITIAL_UNREAD_STATE,

  setUnreads: (data) => {
    const unreadByTaskGroup: Record<string, Set<string>> = {};
    data.forEach(({ taskGroupId, inboxEntryIds }) => {
      unreadByTaskGroup[taskGroupId] = new Set(inboxEntryIds);
    });
    set({ unreadByTaskGroup });
  },

  markAsRead: (inboxEntryId, taskGroupId) => {
    set((state) => {
      const existing = state.unreadByTaskGroup[taskGroupId];
      if (!existing?.has(inboxEntryId)) {
        return state;
      }
      const updated = new Set(existing);
      updated.delete(inboxEntryId);
      return {
        unreadByTaskGroup: {
          ...state.unreadByTaskGroup,
          [taskGroupId]: updated,
        },
      };
    });
  },

  addUnread: (inboxEntryId, taskGroupId) => {
    set((state) => {
      const existing = state.unreadByTaskGroup[taskGroupId];
      if (existing?.has(inboxEntryId)) {
        return state;
      }
      const updated = new Set(existing);
      updated.add(inboxEntryId);
      return {
        unreadByTaskGroup: {
          ...state.unreadByTaskGroup,
          [taskGroupId]: updated,
        },
      };
    });
  },

  isUnread: (inboxEntryId) => {
    return Object.values(get().unreadByTaskGroup).some((entryIds) =>
      entryIds.has(inboxEntryId),
    );
  },

  getDoboxCount: () => {
    return Object.values(get().unreadByTaskGroup).reduce(
      (acc, entryIds) => acc + entryIds.size,
      0,
    );
  },

  getDoboxCountByTaskGroup: (taskGroupId) => {
    return get().unreadByTaskGroup[taskGroupId]?.size ?? 0;
  },

  resetState: () => set(INITIAL_UNREAD_STATE),
});
